import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface BreadcrumbContextValue {
  pageTitle: string;
  setPageTitle: (title: string) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextValue>({
  pageTitle: "",
  setPageTitle: () => {},
});

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [pageTitle, setPageTitleRaw] = useState("");
  const setPageTitle = useCallback((t: string) => setPageTitleRaw(t), []);

  return (
    <BreadcrumbContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb() {
  return useContext(BreadcrumbContext);
}
